import { ViewModel,View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";


export class AccountGatewaySelectorViewModel extends SelectorBaseViewModel<account>{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    public getTypeId(): string {
        return "VM-9A5AC8B3-1887-44ED-9E60-5867AD5F358F"
    }

    protected async loadData(): Promise<account[]> {
        let result =await ServerConnection.callServer('/Complex/ArapRawDataServices/GetAccessibleAccountGateways',{})
        return result.Accounts.map(x=>{
            let r = new account(this);
            r.id = x.Id;
            r.accountId = x.AccountId;
            r.title = `${x.AccountName}`;
            return r;
        });
    }

}

export class account extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set accountId(v: string) { this._accountId = v; } public get accountId(): string { return this._accountId;} private _accountId: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    
}